export default __webpack_public_path__ + "static/media/RTR2004V_Frente.363f51cf.webp";